import ApplicationController from "../../javascript/controllers/application_controller";

export default class extends ApplicationController {
  static targets = ['chart']
  static values = {
    series: Array,
    unit: { type: String, default: 'month' },
    type: { type: String }
  }

  chart = null

  connect() {
    this.draw()
  }

  draw() {
    console.log(this.series)
    this.chart = JSC.Chart(this.chartTarget, {
      defaultCultureName: 'it-IT',
      template: this.options,
      height: this.height,
      series: this.series
    })
  }

  get series() {
    return this.seriesValue
  }

  get height() {
    return 400
  }

  get unit() {
    return this.unitValue
  }
}
